import React from 'react';
import { ItemUtils, ShapeType, ItemClass } from '@marvelapp/design-creator';
import { LayerFolderIcon, LayerFolderOpenIcon, LayerImageIcon, LayerOvalIcon, LayerPathIcon, LayerRoundedIcon, LayerSymbolIcon, LayerTextIcon, } from './icons';
import { isSymbolLayer } from './utils';
export function LayerIcon(_a) {
    var isCollapsed = _a.isCollapsed, item = _a.item;
    var className = ItemUtils.getClassName(item);
    switch (className) {
        case ItemClass.Group: {
            if (isSymbolLayer(item)) {
                return React.createElement(LayerSymbolIcon, null);
            }
            return isCollapsed ? React.createElement(LayerFolderIcon, null) : React.createElement(LayerFolderOpenIcon, null);
        }
        case ItemClass.Raster:
            return React.createElement(LayerImageIcon, null);
        case ItemClass.Shape:
            if (item.type === ShapeType.Ellipse) {
                return React.createElement(LayerOvalIcon, null);
            }
            if (item.type === ShapeType.Rectangle) {
                return React.createElement(LayerRoundedIcon, null);
            }
            return React.createElement(LayerPathIcon, null);
        case ItemClass.CompoundPath:
        case ItemClass.Path:
            return React.createElement(LayerPathIcon, null);
        case ItemClass.Text:
            return React.createElement(LayerTextIcon, null);
        default:
            return React.createElement("div", null, "?");
    }
}
